import notificationService from '../services/notificationService';
import { NotificationAction } from '../types/NotificationAction';
import NotificationBody from '../types/NotificationBody';
import { ServerAlertAction } from '../../common'
import { ServerAlertActionV2 } from '../../common/types/ServerAlertActionV2';
import { VARIANT } from '../../common/types/ServerAlertDataV2';

const getNotificationList = (limit: number, skip: number) => (dispatch: any) => {
    const success = (data: NotificationBody[]): NotificationAction =>
        ({ type: 'GET_NOTIFICATION_LIST', data });

    notificationService.readNotification( limit, skip)
        .then(
            (res: any) => { dispatch(success(res)) },
        );
}

const getNotificationCount = () => (dispatch: any) => {
    const success = (data: number): NotificationAction =>
        ({ type: 'GET_NOTIFICATION_COUNT', data });
    notificationService.getNotificationsCount()
        .then(
            (res: any) => { dispatch(success(res)) },
        );
}

const clearNotification = () => (dispatch: any) => {
    const success = (): NotificationAction =>
        ({ type: 'CLEAR_NOTIFICATION' });
    dispatch(success())
}



const showMsg = (msg: string,vari:any) => {

    const showAlert = (message: string, variant: 'error' | 'success' = 'error'): ServerAlertAction => ({
        type: 'SHOW_ALERT', data: { message: message, variant: variant, openSnackbar: true }
    })
    return (dispatch: any) => {
        dispatch(showAlert(msg, vari));
    }
}

const showMsgLogOut = (msg: string,vari:any) => {

    const showAlert = (message: string, variant: VARIANT = VARIANT.LOGIN_SUCCESS): ServerAlertActionV2 => ({
        type: 'SHOW_ALERT', data: { message: message, variant: variant, openSnackbarV2: true }
    })
    return (dispatch: any) => {
        dispatch(showAlert(msg, vari));
    }
}


export {
    getNotificationList,
    getNotificationCount,
    clearNotification,
    showMsg,
    showMsgLogOut
};